//
// Copyright 2022 DXOS.org
//

import { EventEmitter } from 'events';

export { EventEmitter };

export default { EventEmitter };
